export const app_language_en = {
  tr: 'Turkish',
  en: 'English',
};
